// extracted by mini-css-extract-plugin
module.exports = {"button":"Utilities_VideoPlayIcon_button","icon":"Utilities_VideoPlayIcon_icon"};